import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalService } from '@src/shared/modal/modal.service';
import { Device, DeviceService } from '../../../../woo_services.module/DeviceService';

@Component({
  selector: 'manage-devices',
  templateUrl: './manage-devices.component.html',
  styleUrls: ['../../shared/table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ManageDevices implements OnInit {
  @Input('headerPos') parentHeader: HTMLElement;
  devices: Device[];

  readonly tableHeaders = ['Namn', 'Aktiv', 'Klickbar', 'AG', 'Paus'];

  constructor(
    private deviceService: DeviceService,
    private modalService: ModalService,
    private changeDetection: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      this.devices = await this.deviceService.getDevices();
    } finally {
      this.changeDetection.markForCheck();
    }
  }

  async updateDevices(): Promise<void> {
    await this.deviceService.updateDevices(this.devices);
    this.modalService.openSuccess('Enheterna har uppdaterats.');
  }
}
